module.exports = __webpack_public_path__ + "img/business_intro_4.b8810d93.jpg";